import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=74d42851"
import script from "./Ticker.vue?vue&type=script&lang=js"
export * from "./Ticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d42851')) {
      api.createRecord('74d42851', component.options)
    } else {
      api.reload('74d42851', component.options)
    }
    module.hot.accept("./Ticker.vue?vue&type=template&id=74d42851", function () {
      api.rerender('74d42851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/Ticker.vue"
export default component.exports